module.exports = __webpack_public_path__ + "static/img/slide1.fb1a713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/appInstavice/slide1.jpg
// module id = dCbq
// module chunks = 1